export const PULL_INVENTORY = 'PULL_INVENTORY';
export const SET_INVENTORY = 'SET_INVENTORY';
export const SET_INVENTORY_LOADING = 'SET_INVENTORY_LOADING';

export const pullInventoryAction = () => ({ type: PULL_INVENTORY });
export const setInventoryAction = payload => ({ type: SET_INVENTORY, payload });
export const setInventoryLoadingAction = payload => ({ type: SET_INVENTORY_LOADING, payload });
